import { Angle, ErrorIllustration } from "@miplatform/assets";
import {
  CONTACT_SUPPORT_MESSAGE,
  PAGE_ACCESS_FAIL,
  SOMETHING_WENT_WRONG,
} from "@miplatform/constants";
import { useTheme } from "@mui/material";

export function ErrorPage({ error }) {
  const theme = useTheme();

  return (
    <div style={{ display: "flex", flexGrow: 1, height: "100vh" }}>
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "60%" }}>
          <h1
            style={{
              fontWeight: 800,
              borderBottom: `2px solid ${theme.palette.primary.main}`,
            }}
          >
            {SOMETHING_WENT_WRONG}
          </h1>
          <p
            style={{
              fontSize: 32,
            }}
          >
            {error || PAGE_ACCESS_FAIL}
          </p>
          <p style={{ color: theme.palette.grey.darkAccent }}>
            {CONTACT_SUPPORT_MESSAGE}
          </p>
        </div>
      </div>
      <div
        style={{
          flex: 1,
          backgroundImage: `url(${Angle})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          alt=""
          src={ErrorIllustration}
          style={{
            maxWidth: "100%",
            height: "auto",
          }}
        />
      </div>
    </div>
  );
}
